import type { RawChargerFullStatus } from 'utils/communication/fullstatus';
import type { ReadStateTemplate } from 'utils/communication/websocketTypes';

export type Countries =
  | 'austria'
  | 'germany'
  | 'switzerland'
  | 'denmark'
  | 'france'
  | 'norway'
  // | 'australia'
  | 'belgium'
  | 'bulgaria'
  | 'croatia'
  | 'cyprus'
  | 'czech_republic'
  | 'finland'
  | 'greece'
  | 'hungary'
  | 'ireland'
  | 'italy'
  | 'luxembourg'
  | 'netherlands'
  | 'new_zealand'
  | 'northern_ireland'
  | 'poland'
  | 'portugal'
  | 'romania'
  | 'slovakia'
  | 'slovenia'
  | 'spain'
  | 'sweden'
  | 'turkiye'
  | 'uk'
  | 'default';

export type CountryPreset = Record<
  Countries,
  Required<
    Pick<
      ReadStateTemplate<RawChargerFullStatus>,
      'la1' | 'ula' | 'ule' | 'ulu' | 'uve'
    >
  >
>;

export type CountryCodes = Record<Countries, string>;

export const countryCodes: CountryCodes = {
  austria: 'AT',
  germany: 'DE',
  switzerland: 'CH',
  denmark: 'DK',
  france: 'FR',
  norway: 'NO',
  // australia: 'AU', // NOTE: The Australian variant will not be supported, but let's keep the code for possible usage in future
  belgium: 'BE',
  bulgaria: 'BG',
  croatia: 'HR',
  cyprus: 'CY',
  czech_republic: 'CZ',
  finland: 'FI',
  greece: 'GR',
  hungary: 'HU',
  ireland: 'IE',
  italy: 'IT',
  luxembourg: 'LU',
  netherlands: 'NL',
  new_zealand: 'NZ',
  northern_ireland: 'GB-NIR',
  poland: 'PL',
  portugal: 'PT',
  romania: 'RO',
  slovakia: 'SK',
  slovenia: 'SI',
  spain: 'ES',
  sweden: 'SE',
  turkiye: 'TR',
  uk: 'GB',
  default: 'default',
};

const countryPresets: CountryPreset = {
  austria: {
    la1: 16,
    ule: true,
    ulu: true,
    ula: 16,
    uve: true,
  },
  germany: {
    la1: 16,
    ule: true,
    ulu: false,
    ula: 20, // 4,6 kva
    uve: false,
  },
  switzerland: {
    la1: 8,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  denmark: {
    la1: 6,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  france: {
    la1: 8,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  norway: {
    la1: 10,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  // NOTE: The Australian variant will not be supported, but let's keep the code for possible usage in future
  // australia: {
  // la1: 16,
  // ule: false,
  // ulu: true,
  // ula: 32,
  // uve: false,
  // },
  belgium: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  bulgaria: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  croatia: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  cyprus: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  czech_republic: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  finland: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  greece: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  hungary: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  ireland: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  italy: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  luxembourg: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  netherlands: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  new_zealand: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  northern_ireland: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  poland: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  portugal: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  romania: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  slovakia: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  slovenia: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  spain: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  sweden: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  turkiye: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  uk: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
  default: {
    la1: 16,
    ule: false,
    ulu: true,
    ula: 32,
    uve: false,
  },
};

export type CountryDelayPreset = Record<
  Countries,
  Required<
    Pick<
      ReadStateTemplate<RawChargerFullStatus>,
      'rdbs' | 'rdes' | 'rdbf' | 'rdef' | 'rdre' | 'rdpl'
    >
  >
>;

export const countryDelayPresets: CountryDelayPreset = {
  austria: {
    rdbs: 300,
    rdes: 0,
    rdbf: 300,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  uk: {
    rdbs: 600,
    rdes: 600,
    rdbf: 600,
    rdef: 600,
    rdre: 0,
    rdpl: 600,
  },
  germany: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  switzerland: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  denmark: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  france: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  norway: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  // australia: { // NOTE: The Australian variant will not be supported, but let's keep the code for possible usage in future
  // 	rdbs: 0,
  // 	rdes: 0,
  // 	rdbf: 0,
  // 	rdef: 0,
  // 	rdre: 0,
  // 	rdpl: 0,
  // },
  belgium: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  bulgaria: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  croatia: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  cyprus: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  czech_republic: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  greece: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  hungary: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  ireland: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  italy: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  luxembourg: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  netherlands: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  new_zealand: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  northern_ireland: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  poland: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  portugal: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  romania: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  slovakia: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  slovenia: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  spain: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  sweden: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  finland: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  turkiye: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
  default: {
    rdbs: 0,
    rdes: 0,
    rdbf: 0,
    rdef: 0,
    rdre: 0,
    rdpl: 0,
  },
};

export const countryCodeToCountry = (
  code: (typeof countryCodes)[keyof typeof countryCodes],
): Countries | null => {
  return Object.keys(countryCodes).find(
    country => countryCodes[country as Countries] === code,
  ) as Countries | null;
};

export default countryPresets;
